(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    function getUaCheckoutForm() {
    var existing = document.querySelector('.ua-checkout-redirect-form');
    if (existing) return existing;
    var form = document.createElement('form');
    form.action = '/checkout';
    form.method = 'post';
    form.hidden = true;
    form.className = 'ua-checkout-redirect-form';
    document.body.appendChild(form);
    return form;
  }
  // Create it immediately (not inside the click handler) so Chekly's
  // MutationObserver has time to attach its submit listener before anyone clicks.
  getUaCheckoutForm();

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.ua-buy-now-button');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true;

    var variantId = button.getAttribute('data-variant-id');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Add to cart failed (status ' + response.status + ')');
          }
          return data;
        });
      })
      .then(function () {
        var form = getUaCheckoutForm();
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      })
      .catch(function (err) {
        console.error('UA buy now error:', err);
        button.disabled = false;
        alert('ПОМИЛКА ДІАГНОСТИКИ: ' + err.message);
      });
  });
  } catch(e) { console.error(e); }
})();

})();
